
export const routes = [
  {
    name: 'Home',
    path: '/',
    component: () => import('../../components/containers/HomeContainer'),
    meta: {
      requiresAuth: true,
      hasTour: true,
    },
  },
  {
    name: 'LogIn',
    path: '/Login/:resetRequested?',
    component: () => import('../../components/containers/LogInContainer'),
    meta: {
      requiresAuth: false,
      title: 'futalis Vet: Login für futalis Partnerpraxen',
      metaTags: [
        {
          name: 'description',
          content:
              'Hier anmelden für Ihren persönlichen Tierarztbereich. Sie haben noch keinen Account?' +
              ' Registrieren Sie sich jetzt unverbindlich für eine kostenfreie Testphase.',
        },
        {
          property: 'og:description',
          content:
              'Hier anmelden für Ihren persönlichen Tierarztbereich. Sie haben noch keinen Account?' +
              ' Registrieren Sie sich jetzt unverbindlich für eine kostenfreie Testphase.',
        },
      ],
    },
  },
  {
    name: 'checkout',
    path: '/cart/:petId?',
    component: () => import('@/components/containers/CheckOut'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'Configurator',
    path: '/Configurator/:mode/:id?',
    component: () => import('@/components/containers/Configurator'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'orphanPets',
    path: '/orphanpets',
    component: () => import('../../components/containers/HomeContainer'),
    meta: {
      requiresAuth: true,
      hasTour: true,
    },
  },
  {
    name: 'RationCheck',
    path: '/ration/:petId',
    component: () => import('@/components/containers/RationCheck'),
    meta: {
      requiresAuth: true,
      hasTour: true,
    },
  },
  {
    name: 'RationResults',
    path: '/results/:petId',
    component: () => import('@/components/containers/RationResults'),
    meta: {
      requiresAuth: true,
      hasTour: true,
    },
  },
  {
    name: 'success',
    path: '/success/:id',
    component: () => import('@/components/containers/Success'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'forgotPassword',
    path: '/forgotPassword/',
    component: () => import('@/components/containers/ForgotPassword'),
    meta: {
      requiresAuth: false,
    },
  },
  {
    name: 'faq',
    path: '/faq',
    component: () => import('../../components/containers/HomeContainer'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: 'NotFound',
    path: '/404',
    component: () => import('@/components/containers/NotFound'),
    meta: {
      requiresAuth: false,
    },
  },
  { path: '*', redirect: '/404' },
];
